import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';
import RedBag from './RedBag/script';
import { COUPON_STATUS } from '../constants/index';
import Describe from '../utils/lib/describe';

const { isFunction, createUniqueId } = common;

const defaultTitle = '大额外卖红包';
const defaultSubtitle = '部分商家可用';
const defaultUseBtn = '去使用';
const defaultGetBtn = '去领取';

const COMPONENT_ID = 'waimai_lf2qcxgl';
const SUB_COMPONENT_RED_BAG_ID = 'waimai_31pa3pum';

const describeRedBagList = new Describe('RedBagList', COMPONENT_ID);
const describeRedBag = new Describe('RedBag', SUB_COMPONENT_RED_BAG_ID);

describeRedBagList.setSubComponent('RedBag', describeRedBag);

const throwError = () => {
    throw new Error('请检查红包列表');
};
const renderBig = (props) => RedBag({ size: 'big', ...props });
const renderMiddle = (props) => RedBag({ size: 'middle', ...props });
const renderSmall = (props) => RedBag({ size: 'small', ...props });

class RedBagList {
    static describe = describeRedBagList;
    constructor(props = {}) {
        this.redBagUniqueId = createUniqueId();
        this.propsCache = props;
        this.component = this.createDom(props);
    }
    createDom = (props) => {
        const {
            redBagArrList = [],
            onClickBtn,
            onClickReceiveAll,
            title = defaultTitle,
            subtitle = defaultSubtitle,
            useBtn = defaultUseBtn,
            getBtn = defaultGetBtn,
        } = props;

        const rules = {
            count_0: throwError,
            count_1: renderBig,
            count_2: renderMiddle,
            count_3: renderSmall,
            default: renderSmall,
        };
        const renderCouponFunc = rules[`count_${redBagArrList.length}`] || rules['default'];

        const isShowUse = redBagArrList.some(
            (poiInfo) => poiInfo.giftInfo.status === COUPON_STATUS.STATUS_RECEIVED,
        );

        const renderProps = {
            redBagArrList,
            onClickBtn,
            onClickReceiveAll,
            title,
            subtitle,
            useBtn,
            getBtn,
            isShowUse,
        };
        const data = {
            redBagUniqueId: this.redBagUniqueId,
            dom: renderCouponFunc(renderProps),
            isShowUse,
        };
        const events = {
            onClickReceiveAllBtn: async () => {
                if (isFunction(onClickReceiveAll)) {
                    await onClickReceiveAll(redBagArrList);
                }
            },
        };
        return createComponent(tpl, { data, style }, events);
    };
    getComponent = () => {
        return this.component;
    };
    render = (props) => {
        const container = dom.$id(this.redBagUniqueId);
        this.component = this.createDom({ ...this.propsCache, ...props });
        container.outerHTML = this.component;
    };
}

export default RedBagList;
